import { gql } from "@apollo/client";

export const GET_PAYMENT = gql`
  query payment($id: String!) {
    payment(id: $id) {
      stripePaymentIntentSecret
    }
  }
`;
